import $ from 'jquery'

export default function scrollToTop() {
  $('html, body')
    .stop()
    .animate({ scrollTop: 0 }, 300)
}
